import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setIndicators, setMapIndicators, setWorkspaceLoaded } from 'store/workspaceSlice';
import { listWorkspaces, getWorkspaceById} from '../../../store/auth';
import { useAuth } from 'components/authentication/signup-login/AuthContext';
export const useAutoLoadDefaultWorkspace = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useAuth();
  const selectedIndicators = useSelector(state => state.workspace.selectedIndicators);
  const selectedMapFeatures = useSelector(state => state.workspace.selectedMapFeatures);
  const isWorkspaceLoaded = useSelector(state => state.workspace.isWorkspaceLoaded);
  const isNewWorkspaceStarted = useSelector(state => state.workspace.isNewWorkspaceStarted);

  useEffect(() => {
    const loadDefault = async () => {
      if (isAuthenticated && !isWorkspaceLoaded && 
          selectedIndicators.length === 0 && selectedMapFeatures.length === 0 &&
          !isNewWorkspaceStarted) {
        
        try {
          const response = await listWorkspaces();
          const workspaces = response.data?.workspaces || response.workspaces || response;
          const defaultWorkspace = workspaces.find(ws => ws.user_default === true);
          
          if (defaultWorkspace) {
            const workspaceResponse = await getWorkspaceById(defaultWorkspace.id);
            const fullWorkspaceData = workspaceResponse.data.workspace;
            const workspaceData = typeof fullWorkspaceData.ws_data === 'string' 
              ? JSON.parse(fullWorkspaceData.ws_data) 
              : fullWorkspaceData.ws_data;

            if (workspaceData.savedIndicators?.length > 0) {
              dispatch(setIndicators(workspaceData.savedIndicators));
            }
            
            if (workspaceData.savedLocations?.length > 0) {
              const normalizedLocations = workspaceData.savedLocations.slice(1).map(loc => ({
                id: loc.id || loc.value || loc.lgd_code || null,
                name: loc.label || loc.lgd_name || loc.name || '',
                geo_level: loc.geo_level || loc.geo_level_code || null,
                properties: {
                  id: loc.id || loc.value || loc.lgd_code || null,
                  code: loc.value || loc.lgd_code || null,
                  name: loc.label || loc.lgd_name || loc.name || '',
                  geo_level_code: loc.geo_level || loc.geo_level_code || null,
                }
              }));
              dispatch(setMapIndicators(normalizedLocations));
            }

            dispatch(setWorkspaceLoaded({
              id: fullWorkspaceData.id,
              name: fullWorkspaceData.ws_name
            }));
          }
        } catch (error) {
        }
      }
    };

    loadDefault();
  }, [isAuthenticated, isWorkspaceLoaded, selectedIndicators.length, selectedMapFeatures.length, isNewWorkspaceStarted]);
};